import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import RenderNumberInput from '../../components/ReduxForm/RenderNumberInput';
import RenderDropdownList from '../../components/ReduxForm/RenderDropdownList';
import RenderDatePicker from '../../components/ReduxForm/RenderDatePicker';
import RenderTextInput from '../../components/ReduxForm/RenderTextInput';
import {
  validateRequired,
  validateEmail,
  validateTelephone,
  exceedLimit
} from '../../helpers/formValidation.helper';
import {BookTableButton, BookTableWrapper, ButtonText, FormError} from './TableBookingForm.style';
import {FieldRow, Label, FieldDiv} from '../CheckoutPage/CheckoutPage.style';
import {ButtonSpinner} from '../../styles/components/button.style';

class TableBookingForm extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (!nextProps.generalOpeningTimes || this.props.selectedDate === nextProps.selectedDate) {
      return;
    }
    return this.props.changeFormValue('tableBookingForm', 'time', nextProps.generalOpeningTimes[0]);
  }
  render() {
    const {
      error,
      config,
      selectedDate,
      onDateChange,
      generalOpeningTimes,
      isDayBlocked,
      handleSubmit,
      submitting
    } = this.props;
    const renderGuests = config && config.maxGuests &&
      <FieldRow>
        <FieldDiv nomargin>
          <Label for="guests">
            <FormattedMessage id="booking.guests" />
          </Label>
          <Field
            name="guests"
            min={1}
            max={config.maxGuests}
            initialValues={2}
            component={RenderNumberInput}
            validate={exceedLimit(config.maxGuests)}
          />
        </FieldDiv>
      </FieldRow>;
    const renderDateField = selectedDate &&
      <FieldRow>
        <FieldDiv nomargin>
          <Label for="date">
            <FormattedMessage id="booking.date" />
          </Label>
          <Field
            name="date"
            initialValues={selectedDate}
            date={selectedDate}
            onDateChange={onDateChange}
            isDayBlocked={isDayBlocked}
            component={RenderDatePicker}
          />
        </FieldDiv>
    </FieldRow>;
    const renderTimesSlot = generalOpeningTimes &&
      <FieldRow>
        <FieldDiv nomargin>
          <Label for="time">
            <FormattedMessage id="booking.time" />
          </Label>
          <Field
            id="time"
            name="time"
            data={generalOpeningTimes}
            component={RenderDropdownList}
          />
        </FieldDiv>
      </FieldRow>;
    const isProcessing = submitting || !generalOpeningTimes || !selectedDate;
    const renderSubmitButton = (
      <BookTableWrapper>
        <BookTableButton
          type="submit"
          disabled={isProcessing}
        >
        {
          isProcessing ? <ButtonSpinner /> : <ButtonText><FormattedMessage id="booking.bookTable" /></ButtonText>
        }
        </BookTableButton>
      </BookTableWrapper>
    );
    const renderErrors = error && error.map(err => <FormError key={err}>{err}</FormError>);
    return (
      <form onSubmit={handleSubmit}>
        {renderErrors}
        <FieldRow>
          <FieldDiv nomargin>
            <Label for="name">
              <FormattedMessage id="booking.name" />
            </Label>
            <Field
              id="name"
              name="name"
              type="text"
              component={RenderTextInput}
              validate={[validateRequired]}
            />
          </FieldDiv>
        </FieldRow>
        <FieldRow>
          <FieldDiv nomargin>
            <Label for="email">
              <FormattedMessage id="booking.email" />
            </Label>
            <Field
              id="email"
              name="email"
              type="email"
              validate={[validateRequired, validateEmail]}
              component={RenderTextInput}
            />
          </FieldDiv>
        </FieldRow>
        <FieldRow>
          <FieldDiv nomargin>
            <Label for="phone">
              <FormattedMessage id="booking.phone" />
            </Label>
            <Field
              id="phone"
              name="phone"
              type="tel"
              validate={[validateRequired, validateTelephone]}
              component={RenderTextInput}
            />
          </FieldDiv>
        </FieldRow>
        {renderGuests}
        {renderDateField}
        {renderTimesSlot}
        {renderSubmitButton}
      </form>
    );
  }
}

TableBookingForm.propTypes = {
  restaurant: PropTypes.object.isRequired,
  config: PropTypes.object,
  generalOpeningTimes: PropTypes.array,
  selectedDate: PropTypes.object,
  onDateChange: PropTypes.func.isRequired,
  isDayBlocked: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  changeFormValue: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.array
};

const mapStateToProps = () => {
  return {
    initialValues: {
      guests: 2
    }
  };
};

const form = {
  form: 'tableBookingForm',
  destroyOnUnmount: true
};

export default connect(mapStateToProps)(
  reduxForm(form)(
    TableBookingForm
  )
);



// WEBPACK FOOTER //
// ./containers/TableBooking/TableBookingForm.js